<template>
	<popup title="Select your product category/tax code" class="tax-codes-popup" @close="close" noscroll>
		<template v-slot:content>
			<div class="content noscroll">
				<loading v-if="loading" />
				<div v-else class="layout-column noscroll">
					<div class="flex-none">
						<input-field class="search-input" v-model="search"
						             :icon="require('@/assets/img/search-icon.svg')" placeholder="Search..."  />
					</div>
					<div class="layout-column scroll list">
						<div v-if="!filteredTaxCodes || filteredTaxCodes.length===0" class="no-results">
							<span>
								No tax codes or categories found<br>
								<span class="" v-if="!taxCodes || !taxCodes.length">(Double check your API Key)</span>
							</span>
						</div>
						<div class="tax-code-entry" v-for="(taxCode, index) in filteredTaxCodes" :key="index"
						@click="selectItem(taxCode)">
							<span class="name">{{taxCode.name}}</span>
							<span class="number">{{taxCode.product_tax_code}}</span>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-slot:actions>
			<v-button label="Cancel" border @click="close"/>
		</template>
	</popup>
</template>

<script>
import API from '@/api'
import Popup from "@/components/base/popup";
import VButton from "@/components/base/v-button";
import InputField from "@/components/base/input-field";
import Loading from "@/components/Loading";

export default {
	name: "tax-codes-popup", components: {Loading, InputField, VButton, Popup}, props:['apiKey', 'appId', 'funnelId'],
	mixins:[API],
	data() {
		return {
			search: '',
			taxCodes: [],
			loading: false,
		}
	},
	computed:{
		filteredTaxCodes() {
			let s = this.search.toLowerCase()
			if (!this.taxCodes) return [];
			return this.taxCodes.filter(x => x.name.toLowerCase().includes(s) || x.product_tax_code.toLowerCase().includes(s))
		},
	},
	methods:{
		selectItem(taxCode) {
			this.$emit("change", taxCode)
		},
		close() {
			this.$emit('close')
		},
		async loadTaxCodes(){
			try {
				this.loading = true;
				this.taxCodes = [];
				if (!this.apiKey) return;

				let tc = await this.api.apps.callMethod(this.appId, this.funnelId, 'get-codes',
						{api_key: this.apiKey})
				if (tc && !tc.error) this.taxCodes = tc;
			} catch (e) {
				this.$error(e)
			} finally {
				this.loading = false;
			}
		},
	},
	created() {
		this.loadTaxCodes()
	}
}
</script>

<style lang="scss" scoped>
.tax-codes-popup {
	.popup {
		position: relative;
		min-height: 400px;
	}
	.content {
		padding: 2px;
		margin: 0;
		position: relative;
		min-height: 100px;
	}
	.no-results {
		padding: 10px 40px;
		display: flex;
		span {
			flex: 1;
			text-align: center;
		}
	}
	.list {
		border: 1px solid silver;
		border-radius: 4px;
		padding: 5px;
		.tax-code-entry {
			padding: 8px 10px;
			display: flex;
			flex-direction: row;
			cursor: pointer;
			&:hover {
				background: $light-blue;
			}
			.name {
				font-weight: 500;
				flex: 1;
			}
			.number {
				font-weight: 600;
				color: $dark-grey;
				cursor: inherit;
			}
		}
	}
	.search-input {
		padding-left: 10px;
		width: auto;
		margin: 2px 2px 6px;
	}
}
</style>
